export const SDK_VERSION = '4.8.0';
export const BEACON_VERSION = '3';
export const NOTIFICATION_ORACLE_URL = 'https://beacon-notification-oracle.dev.gke.papers.tech';
export const BACKEND_URL = 'https://beacon-backend.prod.gke.papers.tech';
//# sourceMappingURL=constants.js.map